<template>
  <div class="kv-ve-ratio" role="group" :aria-label="resolvedLabel">
    <button
      v-for="opt in resolvedOptions"
      :key="opt.value"
      type="button"
      class="kv-ve-ratio__pill"
      :class="{ active: safeValue === opt.value }"
      :title="opt.title || opt.label"
      :aria-label="opt.title || opt.label"
      :aria-pressed="safeValue === opt.value ? 'true' : 'false'"
      @click="$emit('input', opt.value)"
    >
      {{ opt.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: "VeAspectRatioPicker",
  model: { prop: "value", event: "input" },
  props: {
    value: { type: String, default: "auto" }, // auto | "1 / 1" | ...
    label: { type: String, default: "" },
    // Allow overriding options if needed later
    options: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    resolvedLabel() {
      return this.label || this.t("visual_editor-aspect_ratio");
    },
    resolvedOptions() {
      if (Array.isArray(this.options) && this.options.length > 0) {
        return this.options;
      }

      return [
        { value: "auto", label: this.t("visual_editor-auto"), title: this.t("visual_editor-automatic") },
        // i18n-validator-ignore-next-line: technical aspect ratios are universally understood
        { value: "1 / 1", label: "1:1" },
        { value: "16 / 9", label: "16:9" },
        { value: "9 / 16", label: "9:16" },
        { value: "4 / 3", label: "4:3" },
        { value: "3 / 4", label: "3:4" },
        { value: "3 / 2", label: "3:2" },
        { value: "2 / 3", label: "2:3" },
      ];
    },
    safeValue() {
      const v = String(this.value || "");
      const found = this.resolvedOptions.some((o) => String(o?.value) === v);
      return found ? v : "auto";
    },
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
  },
};
</script>

<style scoped lang="less">
.kv-ve-ratio {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.kv-ve-ratio__pill {
  all: unset;
  cursor: pointer;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  background: #ffffff;
  height: 32px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  font-size: 12px;
  font-weight: 400;
  color: #344054;
  transition: box-shadow 0.15s ease, border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
}
.kv-ve-ratio__pill:hover {
  border-color: rgba(42, 170, 76, 0.55);
  box-shadow: 0 0 0 4px rgba(42, 170, 76, 0.12);
}
.kv-ve-ratio__pill.active {
  border-color: rgba(42, 170, 76, 0.85);
  box-shadow: 0 0 0 4px rgba(42, 170, 76, 0.16);
  background: rgba(42, 170, 76, 0.06);
  color: #027a48;
}
</style>




